import { useAppSelector } from '@hooks/app/redux';
import { memberApiV2 } from '@lib/api';
import { AsyncSelect, AsyncSelectProps } from '../../ui/inputs/select';
import React from 'react';
import { useIntl } from 'react-intl';
import { OptionTypeBase } from 'react-select';

interface ExpertiseSelectProps
  extends Omit<
    AsyncSelectProps<OptionTypeBase, false>,
    'loadOptions' | 'placeholder' | 'isMulti' | 'cacheOptions' | 'defaultOptions'
  > {}

const ExpertiseSelect: React.FunctionComponent<ExpertiseSelectProps> = (props) => {
  const { formatMessage } = useIntl();
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;

  const institutionOpts = React.useCallback(
    async (query: string) => {
      const expertise = (
        await memberApiV2.searchExpertise({
          page: 1,
          pageSize: 30,
          sortBy: 'name',
          direction: 'ASC',
          text: query,
        })
      ).data;

      return expertise.data.items.map((e: any) => ({
        value: e.code,
        label: e.name,
      }));
    },
    [providerId],
  );

  return (
    <AsyncSelect
      loadOptions={institutionOpts}
      isMulti={false}
      cacheOptions
      defaultOptions
      placeholder={formatMessage({ id: 'rs_placeholder' })}
      {...props}
    />
  );
};

export default ExpertiseSelect;
